import { css, type SerializedStyles } from '@emotion/react';
import type { DotPosition } from '../types';

export const dotPositionStyles: Record<DotPosition, SerializedStyles> = {
  'top-left': css({ position: 'absolute', top: 4, left: 4 }),
  'top-right': css({ position: 'absolute', top: 4, right: 4 }),
  'middle-left': css({ position: 'absolute', top: '50%', left: 4, transform: 'translateY(-50%)' }),
  'middle-right': css({ position: 'absolute', top: '50%', right: -4, transform: 'translateY(-50%)' }),
  'bottom-left': css({ position: 'absolute', bottom: 4, left: 4 }),
  'bottom-right': css({ position: 'absolute', bottom: 4, right: 4 }),
};
